import {type FC, memo, type SVGProps, useMemo} from 'react';

import styles from './NoResultsHeader.module.css';

interface Props {
  description?: string;
  icon?: FC<SVGProps<SVGSVGElement>>;
  iconSize?: number;
  text: string;
}

const NoResultsHeader: FC<Props> = ({description, icon, iconSize, text}) => {
  const Icon = icon;

  const iconStyle = useMemo(
    () => ({
      height: iconSize,
      width: iconSize,
    }),
    [iconSize],
  );

  return (
    <div className={`NoResultsHeader ${styles.NoResultsHeader}`}>
      {Icon ? (
        <div className={styles.iconContainer}>
          <Icon style={iconStyle} />
        </div>
      ) : null}
      <p className={styles.text}>{text}</p>
      {description ? <p className={styles.description}>{description}</p> : null}
    </div>
  );
};

export default memo(NoResultsHeader);
